import { render, staticRenderFns } from "./ItemListPremiumLayout.vue?vue&type=template&id=498805eb&scoped=true"
import script from "./ItemListPremiumLayout.vue?vue&type=script&lang=js"
export * from "./ItemListPremiumLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498805eb",
  null
  
)

export default component.exports